import _ from 'lodash';
import DataLayer from '@/helpers/dataLayer.js';
import { mapGetters, mapMutations } from 'vuex';

export default {
	mounted() {
		if (this.getSteps[this.getCurrentStep] !== this.$route.name && this.$route.name !== 'comparison') {
			this.$router.push({ name: this.getSteps[this.getCurrentStep] });
		}

		if (_.has(this.$route, 'meta')) {
			if (_.has(this.$route.meta, 'dataLayerEvent')) {
				DataLayer.setEvent(this.$route.meta.dataLayerEvent);
			}
		}
	},
	beforeRouteLeave(to, _from, next) {
		const step = this.getSteps.findIndex(getStep => getStep === to.name);
		this.setCurrentStep(step);
		next();
	},
	computed: {
		...mapGetters([
			'getCurrentStep',
			'getSteps',
			'getCategory',
			'hasMovables',
			'getCalculation',
			'getValuableSum',
			'getValuables',
		]),
	},
	methods: {
		...mapMutations(['setCurrentStep', 'setInputData', 'showPopup', 'setEventInactive', 'removeEventInactive', 'setError']),
		onSubmit(validate = true) {
			if (validate) {
				this.$refs.form.validate().then(success => {
					if (success) {
						this.setNext();
					} else {
						this.scrollIntoViewWithOffset('.error-field:first-of-type');
        				return;
					}
				});
			} else {
				this.setNext();
			}
		},
		scrollIntoViewWithOffset(selector, offset = 30) {
			window.scrollTo({
				behavior: 'smooth',
				top:
					document.querySelector(selector).getBoundingClientRect().top -
					document.body.getBoundingClientRect().top -
					offset,
			})
		},
		onPrev() {
			this.setError(false);
			const step = !this.hasMovables && this.getCurrentStep === 3 ? 1 : this.getCurrentStep - 1;
			this.setCurrentStep(step);
			this.$router.push({ name: this.prevLink });
		},
		setNext() {
			const step = !this.hasMovables && this.getCurrentStep === 1 ? 3 : this.getCurrentStep + 1;
			let route = { name: this.nextLink };

			if (this.nextLink === 'comparison') {
				_.assign(route, { params: { hash: this.getCalculation.hash } });
			}

			if (this.nextLink === 'package-information') {
			}

			if (this.$route.name === 'movable') {
				this.setInputData({
					group: 'real_estate',
					key: 'valuable_value',
					value: this.getValuableSum,
					index: null,
				});

				if (this.getValuableSum > 200000) {
					this.showPopup('Valuable200k');
				}

				this.setEventInactive(22);
			}

			this.setCurrentStep(step);
			this.$router.push(route);
			this.$scrollTo('.statebar', 500);
		},
	},
};
